( function( app ) {
  const COMPONENT = {
    init: function() {
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'cutout-callout', COMPONENT );
} )( app );
